import { Routes } from '@angular/router';
import { QueryParams } from '@framework';
//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [

	//{ path: 'administration', loadChildren: () => import('../../+app/app.module').then(m => m.AppModule) },
	//{ path: 'dashboard', loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)},	
	// { path: '', loadChildren: () => import('../../+cpp/cpp.module').then(m => m.CPPModule) },
	// { path: '', loadChildren: () => import('../../+ims/ims.module').then(m => m.IMSModule) },
	// { path: '', loadChildren: () => import('../../+ifs/ifs.module').then(m => m.IFSModule) },
	// { path: '', loadChildren: () => import('../../+betx/betx.module').then(m => m.BetXModule) },
	// { path: '', loadChildren: () => import('../../+medview/medview.module').then(m => m.MedViewModule) },
	// { path: '', loadChildren: () => import('../../+insure/insure.module').then(m => m.InsureModule) },

	{
		path: '',
		loadChildren: () => {

			// Retrieved Projects From Services Based on Hostname
			let Project = ''

			//Save Hostname in LoggedInUser to load the Module Required for
			// that instance 
			let _LoggedinUser = JSON.parse(localStorage.getItem('LoggedInUser'));
			//console.log(_value)
			//_value ? JSON.parse(_value) : null;

			if (_LoggedinUser) {
				console.log(_LoggedinUser.Project)

				//Load Module Based on Project Name
				Project = _LoggedinUser.Project

				//Load Module Based on Sub Project Name ( if exist )
				if (_LoggedinUser?.SubProject) {
					Project = _LoggedinUser?.SubProject
				}


			} else {
				console.log("No module to load")
				const _returlURL = QueryParams.getUrlParam('returnURL')
				location.href = '/login?returnURL=' + (_returlURL ? _returlURL : location.pathname);
			}


			// if (location.host.toLowerCase().indexOf('localhost:8100') > -1) {
			// 	Project = 'APP'
			// }
			// if (location.host.toLowerCase().indexOf('localhost:8101') > -1) {
			// 	Project = 'IMS'
			// }
			// if (location.host.toLowerCase().indexOf('localhost:8102') > -1) {
			// 	Project = 'IFS'
			// }
			// if (location.host.toLowerCase().indexOf('localhost:8103') > -1) {
			// 	Project = 'CPP'
			// }
			// if (location.host.toLowerCase().indexOf('localhost:8104') > -1) {
			// 	Project = 'BetX'
			// }
			// if (location.host.toLowerCase().indexOf('localhost:8105') > -1) {
			// 	Project = 'MedView'
			// }
			// if (location.host.toLowerCase().indexOf('localhost:8106') > -1) {
			// 	Project = 'INS'
			// }

			console.log('Project To Load', Project)

			//Get the Project Code for Logged in user and load the appropiate module
			//URL not needed for this for the moment
			switch (Project?.toLowerCase()) {
				case 'app': return import('../../+admin/admin.module').then(m => m.AdminModule);
				case 'ims': return import('../../+ims/ims.module').then(m => m.IMSModule);
				case 'ifs': return import('../../+ifs/ifs.module').then(m => m.IFSModule);
				case 'cpp': return import('../../+cpp/cpp.module').then(m => m.CPPModule);
				case 'betx': return import('../../+betx/betx.module').then(m => m.BetXModule);
				case 'medviewadmin': return import('../../+medview/medview.module').then(m => m.MedViewModule);
				case 'insure': return import('../../+insure/insure.module').then(m => m.InsureModule);
				case 'epos': return import('../../+epos/epos.module').then(m => m.ePOSModule);
				case 'epos-delivery': return import('../../+epos/delivery/epos-map.module').then(m => m.ePOSMapModule);
				case 'epos-costing': return import('../../+epos/costing/costing.module').then(m => m.CostingModule);
				case 'rescueline': return import('../../+rl/rl.module').then(m => m.RLModule);
				case 'appauditors': return import('../../+appauditors/app-auditors.module').then(m => m.AppAuditorsModule);
				default: return import('../../+admin/admin.module').then(m => m.AdminModule);
			}

		}
	}



	// PROJECT DEFINE ROUTES
	// { path: '', loadChildren: () => import('../../+cpp/cpp.module').then(m => m.CPPModule) },
	// { path: '', loadChildren: () => import('../../+ims/ims.module').then(m => m.IMSModule) },
	// { path: '', loadChildren: () => import('../../+ifs/ifs.module').then(m => m.IFSModule) },
	// { path: '', loadChildren: () => import('../../+betx/betx.module').then(m => m.BetXModule) },
	// { path: '', loadChildren: () => import('../../+medview/medview.module').then(m => m.MedViewModule) },
	// { path: '', loadChildren: () => import('../../+insure/insure.module').then(m => m.InsureModule) },

];
